const styles = theme => ({
    appBar: {
        position: 'relative',
    },
    contentBody: {
        padding: theme.spacing(6),
        '@media(max-width: 768px)': {
            padding: theme.spacing(2)
        }
    },
    actionButtons: {
        marginRight: theme.spacing(2)
    },
    photo: {
        maxHeight: 200
    },
    namePairContainer: {
        marginBottom: theme.spacing(2)
    },
    warningPanel: {
        marginBottom: theme.spacing(2)
    }
});

export default styles;